import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "inline space-x-1 inline-flex relative"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["active"];
const _hoisted_4 = {
  class: "absolute top-[-1.4rem] sm:top-[-1.6rem] left-0 right-0 left-0 right-0 flex justify-center"
};
const _hoisted_5 = {
  key: 0,
  class: "rounded-full px-1 sm:px-2 text-black text-[0.7rem] sm:text-[0.7rem]",
  style: {
    "background-color": "#E7F4FE",
    "white-space": "nowrap"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CustomTooltip = _resolveComponent("CustomTooltip");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.hints, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      key: i,
      style: {},
      onClick: $event => $options.onSelect(i)
    }, [_createVNode(_component_CustomTooltip, {
      text: item
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        active: _ctx.selectedOptionI === i,
        class: "questionnaireBtn mt-[1.4rem] sm:mt-[1.6rem] py-2 flex justify-center rounded-lg cursor-pointer w-[3.2rem] sm:w-[5rem] relative"
      }, [_createTextVNode(_toDisplayString($props.hints.length - i) + " ", 1), _createElementVNode("div", _hoisted_4, [$props.others?.optionHint?.[i] ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($props.others?.optionHint?.[i]), 1)) : _createCommentVNode("", true)])], 8, _hoisted_3)]),
      _: 2
    }, 1032, ["text"])], 8, _hoisted_2);
  }), 128))]);
}